import { ENUM_KITCHEN_ROLE } from '@cokitchen/cokitchen-auth';
import { STORAGE_KEYS } from '../../helpers/constants';
import { ENUM_STATUS } from '../../helpers/enums';
import {
  statusIsCompletedDispatchOrSearch,
  statusIsDispatch,
  statusIsPackaging,
  statusIsPending,
  statusIsReady,
  statusIsRejected,
  statusIsStarted
} from '../../helpers/permissions.service';

const role = localStorage.getItem(STORAGE_KEYS.ROLE) ?? '';
const firstName = localStorage.getItem(STORAGE_KEYS.FIRST_NAME);

type TextClassType = {
  status: ENUM_STATUS;
  packagingComplete: boolean;
  actionDisabled: boolean;
};
export const getTextClass = ({
  status,
  packagingComplete,
  actionDisabled
}: TextClassType): string => {
  const disabled = isButtonDisabled({ actionDisabled, packagingComplete, status });
  const textStyle = statusIsReady(status)
    ? 'text-[#D50000]'
    : statusIsStarted(status)
    ? 'text-[#D58300]'
    : statusIsPackaging(status) && role.includes('ADMIN')
    ? 'text-[#D58300]'
    : statusIsPackaging(status) && firstName !== 'Packaging'
    ? 'bg-style'
    : statusIsPackaging(status) && firstName === 'Packaging'
    ? 'text-[#D58300]'
    : statusIsCompletedDispatchOrSearch(status) && !disabled
    ? 'text-[#4f4f4f]'
    : statusIsCompletedDispatchOrSearch(status) && disabled
    ? 'text-[#a1a1a1]'
    : statusIsRejected(status)
    ? 'text-white'
    : 'text-[#46AE31]';

  const cursorStyle =
    disabled || (statusIsPackaging(status) && !packagingComplete) ? 'not-allowed-el' : 'pointer';

  return `uppercase mb-0 font-medium text-[16px] ${textStyle} ${cursorStyle}`;
};

type ButtonTextType = {
  status: ENUM_STATUS;
  actionDisabled: boolean;
  packagingComplete: boolean;
  paid: boolean;
  isPickup: boolean;
};
export const getButtonText = ({
  status,
  actionDisabled,
  packagingComplete,
  paid,
  isPickup
}: ButtonTextType): string => {
  return actionDisabled
    ? ''
    : (statusIsPackaging(status) && packagingComplete) ||
      (statusIsStarted(status) && role === ENUM_KITCHEN_ROLE.SHOP_STAFF && packagingComplete)
    ? 'Finish'
    : statusIsPackaging(status) && !packagingComplete
    ? 'In progress'
    : statusIsReady(status)
    ? 'recall'
    : role === ENUM_KITCHEN_ROLE.FRONT_DESK && !paid
    ? 'CONFIRM ORDER'
    : statusIsDispatch(status) && isPickup
    ? 'Complete Order'
    : statusIsDispatch(status) && !isPickup
    ? 'dispatch'
    : statusIsPending(status) && role.includes('ADMIN')
    ? paid
      ? 'START'
      : 'Confirm Order'
    : statusIsPending(status) &&
      role !== ENUM_KITCHEN_ROLE.FRONT_DESK &&
      role !== ENUM_KITCHEN_ROLE.PACKAGING
    ? 'start'
    : 'Print reciept';
};

type IsButtonDisabledType = {
  status: ENUM_STATUS;
  packagingComplete: boolean;
  actionDisabled: boolean;
};
export const isButtonDisabled = ({
  packagingComplete,
  status,
  actionDisabled
}: IsButtonDisabledType): boolean => {
  return [ENUM_STATUS.STARTED, ENUM_STATUS.PENDING, ENUM_STATUS.SEARCH].includes(status)
    ? false
    : (statusIsPackaging(status) && !packagingComplete) || actionDisabled;
};

export const isOrderReady = ({
  showIfOrderIsReady,
  status
}: {
  showIfOrderIsReady: boolean;
  status: ENUM_STATUS;
}) => showIfOrderIsReady && statusIsStarted(status);
